import React, { useState, useEffect, useRef } from 'react';

interface StopwatchProps {
    on: boolean;
    className?: string;
    style?: React.CSSProperties;
    showButton?: boolean;
    startingPoint: Date,
    stopPoint?: Date,
    id?: string
}

export const Stopwatch: React.FC<StopwatchProps> = ({ id, on, className = '', style = {}, showButton = false, startingPoint, stopPoint }) => {
    const [elapsedSeconds, setElapsedSeconds] = useState(0);
    const intervalRef = useRef<NodeJS.Timeout | undefined>(undefined);

    useEffect(() => {
        if (on) {
            // Clear any existing interval
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }

            // Set up interval to update every 200ms
            intervalRef.current = setInterval(() => {
                const elapsed = (Date.now() - startingPoint.getTime()) / 1000;
                setElapsedSeconds(elapsed);
            }, 100);
        } else {
            // Stop the stopwatch
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = undefined;
            }

            if (stopPoint) {
                const elapsed = (stopPoint.getTime() - startingPoint.getTime()) / 1000;
                setElapsedSeconds(elapsed);
            }
            else {
                console.error("[STOP WATCH]: Stop point is not set, " + id);
            }

        }

        // Cleanup function
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = undefined;
            }
        };
    }, [on, startingPoint, stopPoint]);

    // Reset function to reset the stopwatch
    const reset = () => {
        setElapsedSeconds(0);
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = undefined;
        }
    };

    // Format the elapsed time to 2 decimal places
    const formatTime = (seconds: number): string => {
        return seconds.toFixed(2);
    };

    return (
        <div
            className={`stopwatch ${className}`}
            style={{
                transition: 'color 0.2s ease',
                ...style
            }}
        >
            <span className="stopwatch-time">
                {formatTime(elapsedSeconds)}s
            </span>
            {showButton && !on && elapsedSeconds > 0 && (
                <button
                    onClick={reset}
                    style={{
                        marginLeft: '10px',
                        padding: '4px 8px',
                        fontSize: '0.8rem',
                        backgroundColor: '#f0f0f0',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                    title="Reset stopwatch"
                >
                    Reset
                </button>
            )}
        </div>
    );
};

export default Stopwatch;
